import { render } from "./carousel-slide.vue?vue&type=template&id=2d98993a"
import script from "./carousel-slide.vue?vue&type=script&lang=js"
export * from "./carousel-slide.vue?vue&type=script&lang=js"

import "./carousel-slide.vue?vue&type=style&index=0&id=2d98993a&lang=scss"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__